<!-- QrCodeGenerator.vue -->
<template>
  <div style="display: flex; flex-direction: column; align-items: center;">
    <vue-qr 
      :text="qrText" 
      :callback="handleQrGenerated"
      :size="200"
      :margin="10"
    />
    <!-- <button v-if="qrUrl" @click="downloadQR">下载二维码</button> -->
  </div>
</template>

<script>
import VueQr from 'vue-qr';

export default {
  components: { VueQr },
  props: {
    url: { type: String, required: true } // 接收动态生成的URL
  },
  data() {
    return {
      qrText: this.url,
      qrUrl: null
    };
  },
  methods: {
    handleQrGenerated(dataUrl) {
      this.qrUrl = dataUrl; // 保存二维码图片的DataURL
    },
    downloadQR() {
      const link = document.createElement('a');
      link.download = '推荐码.png';
      link.href = this.qrUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
  watch: {
    url(newVal) {
      this.qrText = newVal; // URL变化时更新二维码内容
    }
  }
};
</script>